<template>
  <collapse-default id="recem_nascido_ocorrencia"
                    :condition="recemNascido">
    <template v-slot:header>
      Recém Nascido {{ !recemNascido?' - Nenhum informado':'' }}
    </template>

    <template v-slot:content>
      <div class="row p-2">
        <div class="col-2">
          <label class="resumo-show_label">Cor Pele</label>
          <div class="resumo-show_sublabel">
            {{ (recemNascido.cor_pele || 'Não informado') | firstCapitalize }}
          </div>
        </div>
        <div class="col-2">
          <label class="resumo-show_label">Peso</label>
          <div class="resumo-show_sublabel">
            {{ recemNascido.peso || 'Não informado' }}
          </div>
        </div>
        <div class="col">
          <label class="resumo-show_label">Anomalias ou Defeitos</label>
          <div class="resumo-show_sublabel">
            {{ recemNascido.anomalias_ou_defeitos || 'Não possui' }}
          </div>
        </div>
      </div>
    </template>
  </collapse-default>
</template>

<script>
  import CollapseDefault from "./CollapseDefault"

  export default {
    name: "RecemNascidoCollapse",
    components: {
      CollapseDefault
    },
    props: {
      recemNascido: Object
    }
  }
</script>

<style scoped>

</style>
